<script lang="ts" setup>
import { TuiEmptyState } from '@clickbar/tailwindui-vue'

import { PRODUCTS_KEY, type PageElementOfType } from '../page-builder'
import ProductGridItem from '@/components/Tenant/Product/ProductGridItem.vue'

const props = defineProps<{
  element: PageElementOfType<'products'>
}>()

const allProducts = inject(PRODUCTS_KEY)!

const matchingProducts = computed(() => {
  if (props.element.data.categoryId === null) {
    return []
  }

  return allProducts.value.filter((x) => x.category_id === props.element.data.categoryId)
})
</script>

<template>
  <div>
    <template v-if="element.data.categoryId !== null">
      <TuiEmptyState v-if="matchingProducts.length === 0" title="Keine Tickets." class="!py-4">
        <template #icon="iconProps">
          <ICarbonNoTicket v-bind="iconProps" />
        </template>
      </TuiEmptyState>

      <div v-else class="grid sm:grid-cols-[repeat(auto-fill,minmax(22rem,1fr))] gap-2">
        <ProductGridItem v-for="product in matchingProducts" :key="product.id" :product />
      </div>
    </template>

    <template v-else />
  </div>
</template>
